import { RootState } from '@redux/store';
import { createSelector } from '@reduxjs/toolkit';
import RbacHelpers from 'RBAC/rbac.helpers';

export const selectHasPermissions = createSelector(
  [
    (state: RootState) => state.roles.permissions,
    (_state, permissionRef = []) => permissionRef,
    (_state, _permissionRef, allowAny = false) => allowAny,
  ],
  (permissions, permissionRef = [], allowAny = false) => {
    return RbacHelpers.checkPermissions(permissions, permissionRef, allowAny);
  }
);
